import React from "react";
import { useSelector } from "react-redux";
import classes from "./SystemMessagesEmptyState.module.css";

const SystemMessagesEmptyState = () => {
    const { texts } = useSelector(state => state.translate);
    return (
        <div className={classes.EmptyState}>
            <span className={classes.EmptyStateBold}>{texts.systemMessagesNoMessages}</span>
            <span>{texts.systemMessagesEmptyHint}</span>
        </div>
    );
};

export default SystemMessagesEmptyState;
